/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthenticatedResponse,
} from '../models/index';
import {
    AuthenticatedResponseFromJSON,
    AuthenticatedResponseToJSON,
} from '../models/index';

export interface FacebookAccessTokenAuthRequest {
    accessToken: string;
}

export interface GoogleAccessTokenAuthRequest {
    code: string;
}

/**
 * 
 */
export class ExternalAuthenticationApi extends runtime.BaseAPI {

    /**
     * Creates request options for facebookAccessTokenAuth without sending the request
     */
    async facebookAccessTokenAuthRequestOpts(requestParameters: FacebookAccessTokenAuthRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling facebookAccessTokenAuth().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/auth/ext/facebook/{accessToken}`;
        urlPath = urlPath.replace(`{${"accessToken"}}`, encodeURIComponent(String(requestParameters['accessToken'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Authenticates user by Facebook `accessToken` or creates an account.
     */
    async facebookAccessTokenAuthRaw(requestParameters: FacebookAccessTokenAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticatedResponse>> {
        const requestOptions = await this.facebookAccessTokenAuthRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticatedResponseFromJSON(jsonValue));
    }

    /**
     * Authenticates user by Facebook `accessToken` or creates an account.
     */
    async facebookAccessTokenAuth(requestParameters: FacebookAccessTokenAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticatedResponse> {
        const response = await this.facebookAccessTokenAuthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for googleAccessTokenAuth without sending the request
     */
    async googleAccessTokenAuthRequestOpts(requestParameters: GoogleAccessTokenAuthRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling googleAccessTokenAuth().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/auth/ext/google/{code}`;
        urlPath = urlPath.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Authenticates user by Google `code` or creates an account.
     */
    async googleAccessTokenAuthRaw(requestParameters: GoogleAccessTokenAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticatedResponse>> {
        const requestOptions = await this.googleAccessTokenAuthRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticatedResponseFromJSON(jsonValue));
    }

    /**
     * Authenticates user by Google `code` or creates an account.
     */
    async googleAccessTokenAuth(requestParameters: GoogleAccessTokenAuthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticatedResponse> {
        const response = await this.googleAccessTokenAuthRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
